import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/plugins/element';
import axios from '@/utils/axios';


Vue.prototype.$axios = axios;
Vue.prototype.$formRequest = axios.formRequest.post;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
